module.exports = function() {
  return new Worker(__webpack_public_path__ + "9e92cc3162f0043b208f.worker.js");
};